export function formatName(name: string): string {
  if (!name) return '';

  return name
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function normalizeString(str: string): string {
  const decomposed = str.normalize('NFD'); // Decompose accented characters (e.g., "á" -> "a + ´")
  const withoutAccents = decomposed.replace(/[\u0300-\u036f]/g, ''); // Remove diacritical marks (accents)
  const lowercased = withoutAccents.toLowerCase();

  return lowercased;
}

export function removeAllQueryParams(url: string): string {
  return url.split('?')[0];
}

export default {
  formatName,
  INVISIBEL_CHARACTER: '‎',
  removeAllQueryParams,
};
